<template>
    <div class="c-csm-score__widget" :class="currentClass">
        <div v-if="!displayAddForm">
            <ButtonGroup>
                <Button class="c-csm-score__poor" @click.stop="displayAdd(1)"
                    ><Tooltip
                        :disabled="buffer !== 1"
                        content="The relationship with this Customer is POOR."
                    >
                        <Icon custom="icon icon-smiley-sad-1"></Icon>
                        <Icon custom="icon icon-smiley-sad-2"></Icon> </Tooltip
                ></Button>
                <Button class="c-csm-score__fair" @click.stop="displayAdd(2)"
                    ><Tooltip
                        :disabled="buffer !== 2"
                        content="The relationship with this Customer is FAIR."
                    >
                        <Icon custom="icon icon-smiley-indifferent"></Icon>
                        <Icon custom="icon icon-smiley-indifferent-2"></Icon
                    ></Tooltip>
                </Button>
                <Button class="c-csm-score__good" @click.stop="displayAdd(3)"
                    ><Tooltip
                        :disabled="buffer !== 3"
                        content="The relationship with this Customer is GOOD."
                    >
                        <Icon custom="icon icon-smiley-happy-1"></Icon>
                        <Icon custom="icon icon-smiley-happy-2"></Icon></Tooltip
                ></Button>
            </ButtonGroup>
        </div>
        <div v-else class="c-csm-score__new">
            <Form style="padding: 5px" @submit.native.prevent="handleSubmit">
                <FormItem style="margin-bottom: 6px">
                    <Input
                        v-model="note"
                        type="textarea"
                        placeholder="Add a note (optional)..."
                    ></Input> </FormItem
                ><FormItem style="margin-bottom: 0px">
                    <Button
                        @click.stop="handleCancel"
                        class="float-left text-muted"
                        >Cancel</Button
                    >
                    <Button
                        class="selected float-right"
                        :class="submitClass"
                        html-type="submit"
                        :loading="submitting"
                    >
                        <Icon
                            custom="icon icon-smiley icon-smiley-happy-1"
                        ></Icon>
                        <Icon
                            custom="icon icon-smiley icon-smiley-indifferent"
                        ></Icon>
                        <Icon
                            custom="icon icon-smiley icon-smiley-sad-1"
                        ></Icon>
                        Update
                    </Button>
                </FormItem></Form
            >
        </div>
    </div>
</template>

<script>
export default {
    props: {
        entity: Object,
        value: {
            type: Number,
            default: null,
        },
        activitiesRepository: {
            type: Object,
            default: () => {
                return new (require("@/js/repositories/activities.js"))();
            },
        },
    },
    components: {
        CsmScore: function () {
            return import("@/js/components/partials/csm-score");
        },
    },
    data() {
        return {
            buffer: this.value,
            displayAddForm: false,
            note: null,
            newScore: null,
            submitting: false,
        };
    },
    computed: {
        submitClass() {
            return {
                "c-csm-score__new-poor": 1 === this.newScore,
                "c-csm-score__new-fair": 2 === this.newScore,
                "c-csm-score__new-good": 3 === this.newScore,
            };
        },
        currentClass() {
            return {
                "c-csm-score__current-poor": 1 === this.buffer,
                "c-csm-score__current-fair": 2 === this.buffer,
                "c-csm-score__current-good": 3 === this.buffer,
            };
        },
    },
    methods: {
        displayAdd(newScore) {
            this.newScore = newScore;
            this.displayAddForm = true;
        },
        handleCancel() {
            this.displayAddForm = false;
        },
        async handleSubmit() {
            let payload = {
                task: this.note,
                comment: this.note,
                type_id: 2,
                csm_score: this.newScore,
                created_by_id: this.$store.getters["me/ID"],
                account_id:
                    1 == this.entity.type_id
                        ? this.entity.id
                        : this.entity.account_id,
                contact_id: 2 == this.entity.type_id ? this.entity.id : null,
                status_id: 1,
            };
            this.submitting = true;
            var response = await this.activitiesRepository.store(payload);
            this.buffer = response.data.data.csm_score;
            this.$root.$emit("activity:created", response.data.data);
            this.reset();
            this.$Message.success({
                content: "CSM Score updated.",
            });
        },
        reset() {
            this.submitting = false;
            this.displayAddForm = false;
            this.note = null;
            this.newScore = null;
        },
    },
};
</script>
